import get, { post } from './client'
import type { ApiResponse } from './types'
import type { AdminInfo, AdminLoginResponse, AdminRsaPublicKey } from './adminTypes'

const unwrap = <T>(res: ApiResponse<T>): T => res.data as T

export interface AdminLoginPayload {
  username: string
  encrypted_password: string
  key_id: string
}

export interface AdminChangePasswordPayload {
  encrypted_old_password: string
  old_password_key_id: string
  encrypted_new_password: string
  new_password_key_id: string
}

export const adminAuthApi = {
  rsaPublicKey: async () =>
    unwrap(await get<ApiResponse<AdminRsaPublicKey>>('/admin/auth/rsa-public-key')),
  login: async (payload: AdminLoginPayload) =>
    unwrap(await post<ApiResponse<AdminLoginResponse>>('/admin/auth/login', payload)),
  logout: async () =>
    unwrap(await post<ApiResponse<{ message: string }>>('/admin/auth/logout', {})),
  me: async () => unwrap(await get<ApiResponse<AdminInfo>>('/admin/auth/me')),
  changePassword: async (payload: AdminChangePasswordPayload) =>
    unwrap(await post<ApiResponse<{ message: string }>>('/admin/auth/change-password', payload)),
}
